export default {
  homeLink: {
    elitego: "菁亿派单",
    aboutLink: "关于菁亿",
    workLink: "合作模式",
    resourceLink: "职位资源",
    contactLink: "联系我们",
  },
  homeAbout: {
    title: "菁亿派单：猎头交易平台",
    briefIntroduction:
      "菁亿派单是一个猎头合作平台，为猎头行业从业员提供优质和可靠的项目资源，一站式解决‘BD难-对接难-成单难’的挑战。我们依靠母公司的业务资源优势，精准对接企业主和管理层，与企业深度绑定，深入了解招聘背景和需要，确保岗位需求真实有效。菁亿派单核心团队由头部猎企顾问和互联网大厂HR组成，熟悉招聘业务运作流程。目前已合作科技大厂、500强、国企民企、专精特新、高潜初创、外资公司等优质企业数百家。",
    structure: "六大服务",
    post: "岗位优势",
    operation: "平台运营",
    information: "信息共享",
    communicate: "客户沟通",
    training: "专业培训",
    consultant: "专属顾问",
  },
  homeWork: {
    title: "合作模式",
    stepNameOne: "签订协议",
    stepNameTwo: "平台做单",
    stepNameThree: "推荐人选",
    stepNameFour: "面 试",
    stepNameFive: "Offer",
    stepNameSix: "佣金分成",
    stepContentOne: "与菁亿派单签订合作协议",
    stepContentTwo: "从菁亿派单的岗位信息中挑选项目交付",
    stepContentThree: "通过善亿派单向雇主推荐匹配的人选",
    stepContentFour: "安排人选与雇主面试",
    stepContentFive: "协助雇主与人选进行offer谈判",
    stepContentSix: "人选入职后，收取佣金",
  },
  homeResource: {
    title: "职位需求",
    one: "AI应用系统架构师",
    two: "自动化工程师",
    three: "机器学习系统开发工程师",
    four: "AIoT开发者工具负责人",
    five: "决策优化算法工程师",
    six: "语音识别算法工程师",
    seven: "NLP大模型算法工程师",
    eight: "推荐系统架构师",
    nine: "搜索推荐产品专家",
    ten: "AI建模工程师",
    eleven: "智能应用开发工程师",
    twelve: "数据标注团队负责人",
    thirteen: "开源算法研究员",
    fourteen: "数据建模工程师",
    fifteen: "自动驾驶算法工程师",
    sixteen: "运动控制算法工程师",
    seventeen: "技术项目管理负责人",
    eighteen: "机器人研发专家",
    nineteen: "融合定位算法专家",
    twenty: "······",

    twentyOne: "CTO",
    twentyTwo: "业务副总经理",
    twentyThree: "博士专家",
    twentyFour: "AI算法工程师",
    twentyFive: "数据库工程师",
    twentySix: "3D视觉算法工程师",
    twentySeven: "嵌入式高级研发工程师",
    twentyEight: "关口表首席专家",
    twentyNine: "数据分析师",
    thirty: "机器视觉算法工程师",
    thirtyOne: "HRD",
    thirtyTwo: "数据科学家",
    thirtyThree: "研发主管",
    thirtyFour: "产品负责人",
    thirtyFive: "解决方案工程师",
    thirtySix: "项目经理",
    thirtySeven: "架构师",

    thirtyEight: "MES负责人",
    thirtyNine: "数字化转型负责人",
    forty: "强化学习算法工程师",
    fortyOne: "大数据架构师",
    fortyTwo: "博士专家",
    fortyThree: "高级技术顾问",
    fortyFour: "数据库内核开发专家",
    fortyFive: "RPA事业部负责人",
    fortySix: "首席信息官",
    fortySeven: "数字化经理",
    fortyEight: "AI产品经理",
    fortyNine: "Unity3D工程师",
    fifty: "嵌入式软件工程师",
    fiftyOne: "仿真工程师",
    fiftyTwo: "深度学习算法工程师",
    fiftyThree: "云容器高级工程师",
    fiftyFour: "自然语言处理算法工程师",
    fiftyFive: "高级全栈工程师",
    fiftySix: "web系统高级开发工程师",
  },
  homeFooter: {
    addressOne: "北京市海淀区德惠路1号院14号楼1至2层3-178",
    branchAddress:
      "中国湖南省长沙市开福区月湖街道匍园路20号聚恒科技园1栋1601房",
    contentOne: "联系我们",
    contentTwo: "公众号",
    record:
      "Copyright © 2025  湖南菁锐人才科技有限公司 版权所有.",
  },
};
